import { strings } from '../lib/strings';
import { CloudOffIcon, EmptySearchIcon, LockIcon } from './Icons';
import { RollLabel } from './RollLabel';

type Kind = 'search' | 'offline' | 'locked';

const ICONS = { search: EmptySearchIcon, offline: CloudOffIcon, locked: LockIcon } as const;

interface Props {
  message: string;
  hint?: string;
  kind?: Kind;
  onRetry?: () => void;
  action?: { label: string; onClick: () => void };
  /** Fill and vertically center within a fixed-height container, such as the viewer. */
  centered?: boolean;
}

/** Mirrors iOS ContentUnavailableView: symbol, title, recovery line, optional action. */
export function EmptyState({ message, hint, kind = 'search', onRetry, action, centered = false }: Props) {
  const Icon = ICONS[kind];
  return (
    <div
      role="status"
      className={`rise-in mx-auto flex max-w-[360px] flex-col items-center text-center ${
        centered ? 'h-full justify-center px-6 py-12' : 'px-4 py-16 sm:py-24'
      }`}
    >
      <Icon className="h-12 w-12 text-subtle" />
      <p className="mt-4 text-xl font-semibold tracking-tight text-ink">{message}</p>
      {hint && <p className="mt-2 text-base text-muted">{hint}</p>}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="cta pressable mt-6 rounded-full bg-fill px-6 py-2 text-base font-semibold text-primary [--cta-fill:var(--color-primary)]"
        >
          <RollLabel>{strings.tryAgain}</RollLabel>
        </button>
      )}
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="cta pressable mt-6 rounded-full bg-primary px-6 py-2 text-base font-semibold text-white"
        >
          <RollLabel>{action.label}</RollLabel>
        </button>
      )}
    </div>
  );
}
